import { AnalyticsService } from '../../typescript/common/analytics-service';
import { MunicipalitySelectorModalHelper } from '../../components/municipality-selector-modal/municipality-selector-modal.helper';

(function newsEvents() {
  if (document.getElementsByClassName('news-block empty-municipality-selection').length > 0) {
    class NewsBlock {
      public init() {
        const muncipalitySelectorModalButton: HTMLElement | null = document.getElementById('municipality-selector-modal-open-button');
        muncipalitySelectorModalButton?.addEventListener('click', () => {
          AnalyticsService.addEvent(AnalyticsService.PaEgnaBenPublic, 'Öppna kommunval');
          MunicipalitySelectorModalHelper.openMunicipalitySelectorModal();
        });
      }
    }
    const page = new NewsBlock();
    page.init();
  }
})();
